import React from 'react';
import { CalculatorIcon, CalendarDaysIcon, ClipboardCheckIcon, GalleryHorizontalEndIcon, NetworkIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { bonuses } from '../data/content';
const ICONS = {
  cards: GalleryHorizontalEndIcon,
  map: NetworkIcon,
  calculator: CalculatorIcon,
  calendar: CalendarDaysIcon,
  check: ClipboardCheckIcon
};
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-brand-ivory text-brand-petrol" data-id="element-28" data-mp="14s9nh7wm9y4n">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-29" data-mp="zv9eao4h0f9b">
        <h2 id="bonos" className="font-display text-4xl leading-none sm:text-5xl" data-id="element-30" data-mp="1ej4bohtfb7sq">
          <span className="rounded-md bg-brand-gold px-2 text-brand-petrol" data-id="element-31" data-mp="1el8c2ps45oo9">
            5 bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-32" data-mp="1njam1uttrrno">
          Además, recibís cinco recursos de estudio{' '}
          <strong className="font-bold text-brand-emerald" data-id="element-33" data-mp="1jkbhwcfx3yxa">
            sin costo adicional.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-34" data-mp="3trxbhcjtq3ip">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-xl border-2 border-brand-gold bg-white text-left" data-id="element-35" data-mp="2k1atcdn6tmn" data-mpi={i}>
                <span className="flex items-center gap-1.5 bg-brand-petrol px-2.5 py-1 font-sub text-xs font-bold uppercase tracking-wide text-brand-gold" data-id="element-36" data-mp="gl5cpsky1jvr">
                  <Icon size={13} aria-hidden="true" data-id="element-37" data-mp="lcvom2zj4fpa" />
                  Bono {i + 1}
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-38" data-mp="qdb0eq45xf55">
                  <h3 className="font-sub text-sm font-bold uppercase leading-tight" data-id="element-39" data-mp="vbcjvc5i3gh5">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-40" data-mp="10709fsnwabn6">
                    {bono.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <p className="mt-3 inline-block rounded-xl border-2 border-dashed border-brand-gold bg-brand-petrol px-3 py-2 font-sub text-sm font-bold leading-tight text-white" data-id="element-41" data-mp="kas8mbvz45cv">
          🎁 Los cinco bonos están incluidos con el pack.
        </p>
      </div>
    </section>;
}